// extracted by mini-css-extract-plugin
export default {"customButton":"PrimaryButton_customButton__GF6dl"};